import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';

const NoData = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'compliance' });

  return (
    <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
      <Typography variant='h5' color={ColorsV2.white} fontSize={'1rem'}>
        {t('no_data')}
      </Typography>
    </Box>
  );
};

export default NoData;
